/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  visit: VisitDtoModelType;
}

/**
 * VisitScheduledDtoBase
 * auto generated base class for the model VisitScheduledDtoModel.
 */
export const VisitScheduledDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('VisitScheduledDto')
  .props({
    __typename: types.optional(types.literal("VisitScheduledDto"), "VisitScheduledDto"),
    /** Visit that is scheduled */
    visit: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => VisitDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class VisitScheduledDtoModelSelector extends QueryBuilder {
  visit(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`visit`, VisitDtoModelSelector, builder) }
}
export function selectFromVisitScheduledDto() {
  return new VisitScheduledDtoModelSelector()
}

export const visitScheduledDtoModelPrimitives = selectFromVisitScheduledDto()
